import { render } from "./ModalMainDisplay.vue?vue&type=template&id=963a2704&scoped=true"
import script from "./ModalMainDisplay.vue?vue&type=script&lang=js"
export * from "./ModalMainDisplay.vue?vue&type=script&lang=js"

import "./ModalMainDisplay.vue?vue&type=style&index=0&id=963a2704&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-963a2704"]])

export default __exports__